import { mapEditorialContent } from '@cobalt/utilities';
import uefaAxios from '@core/axios';
import { loadFromAPIs } from '@utilities/fetch';
import { cobaltApiKey, cobaltApiUrl, cobaltBaseUrl } from '@utilities/WindowContext';

export const loadPoll = (id: string, signal?: AbortSignal) =>
  loadFromAPIs(
    `/pages/${id}`,
    {
      aggregator: 'lightpagejson',
    },
    { apiUrl: cobaltApiUrl, apiKey: cobaltApiKey, signal },
  ).then((response) => {
    if (!response?.model?.data) return null;

    const content = mapEditorialContent(response.model.data, null, true);
    const newPoll = content.body[0];
    newPoll.id = id;
    return newPoll;
  });

export const sendPollVote = async (
  {
    pollId,
    answerId,
    nodeId,
  }: {
    pollId: string;
    answerId: string;
    nodeId: string;
  },
  signal?: AbortSignal,
) => {
  const resp = await uefaAxios.post<{ poll: { pollId: string }; user: { voted: boolean } }>(
    `${cobaltBaseUrl}polls/vote`,
    {
      siteName: 'api-uefa-com',
      pollId,
      answerId,
      nodeId,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      signal,
    },
  );

  if (resp?.status === 409) return { poll: { pollId }, user: { voted: true } };

  return resp.data;
};

const addPerc = (data) => {
  const addedPercentage = data.answers
    .filter(Boolean)
    .map((x) => ({ id: x.id, votes: x.votes, perc: Math.round(x.percentage * 100) }));

  const totalPercentage = addedPercentage.reduce((prev, cur) => prev + cur.perc, 0);

  if (totalPercentage !== 100) {
    const delta = 100 - totalPercentage;
    addedPercentage[addedPercentage.length - 1].perc += delta;
  }

  data.answers = addedPercentage;
  return data;
};

export const loadPollDetails = (id: string, signal?: AbortSignal) =>
  loadFromAPIs(
    'directory/polls/details',
    {
      nodeId: id,
      siteName: 'api-uefa-com',
    },
    { apiUrl: cobaltBaseUrl, apiKey: cobaltApiKey, signal },
  ).then((response) => {
    const res = response?.result?.[0];

    return addPerc(res);
  });
